"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringValue = isStringValue;
exports.isTextValue = isTextValue;
exports.isIntegerValue = isIntegerValue;
exports.isFloatValue = isFloatValue;
exports.isBooleanValue = isBooleanValue;
exports.isLinkValue = isLinkValue;
exports.isDateValue = isDateValue;
exports.isDateTimeValue = isDateTimeValue;
exports.isRatingValue = isRatingValue;
exports.isRelationOneValue = isRelationOneValue;
exports.isRelationManyValue = isRelationManyValue;
exports.isEnumValue = isEnumValue;
function isStringValue(value) {
    return typeof value === 'string';
}
function isTextValue(value) {
    return typeof value === 'string';
}
function isIntegerValue(value) {
    return typeof value === 'number';
}
function isFloatValue(value) {
    return typeof value === 'number';
}
function isBooleanValue(value) {
    return typeof value === 'boolean';
}
function isLinkValue(value) {
    return (value !== null &&
        typeof value === 'object' &&
        value.href !== undefined);
}
function isDateValue(value) {
    return typeof value === 'string';
}
function isDateTimeValue(value) {
    return value instanceof Date;
}
function isRatingValue(value) {
    return typeof value === 'number';
}
function isRelationOneValue(value) {
    return typeof value === 'string';
}
function isRelationManyValue(value) {
    return Array.isArray(value);
}
function isEnumValue(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=valueGuard.js.map